export const GEM_PICKUP_RADIUS_METERS = 80
export const BEATBOX_SWIPE_RADIUS_METERS = 30
export const GEM_COLLECTION_TIMEOUT_MINUTES = 30
export const DEFAULT_LOCATION_DISTANCE_METERS = 800
